import React, { useEffect } from "react";
import * as echarts from "echarts";
import { formatCurrency } from "../../utils/Utils"; // Import formatCurrency utility
import { Empty } from "antd";

const OutstandingPaymentsWidget: React.FC<any> = ({ data }) => {
  // const data = [
  //     { name: '0-15 Days', value: 2356858.8 },    // ₹3,54,892
  //     { name: '16-30 Days', value: 483954.58 },   // ₹2,79,451
  //     { name: '31-45 Days', value: 601239.49 },   // ₹4,31,078
  //     { name: '46-60 Days', value: 347619.29 },  // ₹3,10,986
  //     { name: '>60 Days', value: 2102474.8 },    // ₹2,10,457
  // ];

  useEffect(() => {
    const chartDom = document.getElementById(
      "outstanding-payments-widget"
    ) as HTMLElement;
    const myChart = echarts.init(chartDom);

    const option = {
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          return `${params.name}: ${formatCurrency(params.value, "INR")} (${
            params.percent
          }%)`; // Use formatCurrency for values
        },
      },
      series: [
        {
          name: "Outstanding Payments",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: (params: any) => {
              return `{b|${params.name}}\n{c|${formatCurrency(
                params.value,
                "INR"
              )} (${params.percent}%)}`;
            },
            rich: {
              b: {
                fontSize: 14,
                color: "#333",
                lineHeight: 24,
              },
              c: {
                fontSize: 12,
                color: "#999",
                lineHeight: 20,
              },
            },
          },
          labelLine: {
            show: true,
            length: 15,
            length2: 10,
            smooth: true,
          },
          itemStyle: {
            borderColor: "#E0E4FF", // Border color
            borderWidth: 1, // Border width
            shadowBlur: 10, // Shadow blur
            shadowOffsetX: 0, // Shadow X offset
            shadowOffsetY: 5, // Shadow Y offset
            shadowColor: "rgba(255, 255, 255, 0.2)", // Shadow color
            borderRadius: 5,
          },
          data: data.map((item: any) => ({
            value: item.value,
            name: item.name,
          })),
        },
      ],
      color: ["#173F5F", "#20639B", "#3CAEA3", "#F6D55C", "#ED553B"],
    };

    myChart.setOption(option);

    return () => {
      myChart.dispose();
    };
  }, [data]);

  const TotalValue= data.reduce((total: number, item: any) => total + Number(item.value), 0);
  
  return (
    <>
      <div className="card-title-group mb-1">
        <div className="card-title">
          <h6 className="title">Outstanding Payments</h6>
          <p>Overview of outstanding payments by age group.</p>
        </div>
      </div>
        <div
          id="outstanding-payments-widget"
          style={{ width: "100%", height: "300px" ,display:`${TotalValue ? "block" : "none"}` }}
        />
      {!TotalValue && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          <Empty description="No data available to generate or display the graph." />
        </div>
      )}
    </>
  );
};

export default OutstandingPaymentsWidget;
